import { useMutation } from '@apollo/client';
import { Avatar, Button } from 'antd';
import { InputProps } from 'components/InputFieldsGenerator/types';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import React, { useMemo, useState } from 'react';
import { ICompanyTabProps } from 'routes/Company/types';
import { GeneralIcon } from 'routes/Profile/components/ProfileContent/styled';
import UploadAvatarModal from 'routes/Profile/components/UploadAvatarModal';
import { UPDATE_COMPANY } from 'services/graphql/mutations/company';
import * as Yup from 'yup';

import CommonCompanyForm from '../CommonCompanyForm';

const companyGeneralInfoValidation = {
  name: Yup.string().required('Required'),
};

const GeneralInformation: React.FC<ICompanyTabProps> = ({ refetchCompanyData, portalButtonClassName, company }) => {
  const [toggle, setToggle] = useState(false);
  const { pipeFrom, thumbnailPipeFrom } = company?.avatar || {};
  const [avatarURl, setAvatarURL] = useState(thumbnailPipeFrom);

  const formFields: InputProps[] = useMemo(() => [{ label: 'Company Name', name: 'name' }], []);
  const openUploadModal = () => {
    setToggle(true);
  };

  const closeUploadModal = () => {
    setToggle(false);
  };

  const onAvatarLoad = () => {
    setAvatarURL(pipeFrom);
  };

  const [updateCompany, { loading }] = useMutation(UPDATE_COMPANY);
  const companyId = useCurrentLoggedInUser().company?.id;

  const callUpdateCompany = (v: { name: string }) => {
    updateCompany({
      variables: {
        filter: { id: companyId },
        updatedDoc: v,
      },
    });
  };

  return (
    // const [updateUser, { loading, error }] = useMutation(UPDATE_USER);
    <div className=''>
      <div className='gx-profile-image-container'>
        <Avatar size={150} src={avatarURl} />
        <img style={{ display: 'none' }} src={pipeFrom} onLoad={onAvatarLoad} alt='avatar' />
        <Button
          className='upload-button'
          onClick={openUploadModal}
          icon={<GeneralIcon className='icon icon-upload' size='15px' />}>
          Upload
        </Button>
      </div>
      <CommonCompanyForm
        validationObject={companyGeneralInfoValidation}
        inputProps={formFields}
        initData={company}
        portalButtonClassName={portalButtonClassName}
        loading={loading}
        updateCompany={callUpdateCompany}
        callbackOnSaveSuccess={refetchCompanyData}
      />
      <UploadAvatarModal
        callbackOnUploadSuccess={refetchCompanyData}
        isCompanyAvatar
        visible={toggle}
        onCloseModal={closeUploadModal}
      />
    </div>
  );
};
export default GeneralInformation;
